
export default {
  name: 'UspCard',
  props: {
    usps: {
      default: () => ([]),
      type: Array,
    }
  },
  computed: {
    iconList () {
      return [...this.usps].map(usp => usp.icon)
    },
    titleList () {
      return [...this.usps].map(usp => usp.content)
    }
  }
}
